import React from 'react';
import { AuthRoles } from "components/auth";

export const OrdersConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/orders`,
            component: React.lazy(() => import('./Orders'))
        }
    ]
};